import { ComponentFactoryResolver, EventEmitter, Injectable, ViewContainerRef } from '@angular/core';
import { PuzzleWinDialogInjectableInterface } from './puzzle-win-dialog-injectable.interface';
import { BehaviorSubject, Observable } from 'rxjs';

export enum PUZZLE_WIN_DIALOG_BUTTONS {
  BACK_TO_GAME,
  RESTART_GAME,
}

@Injectable({
  providedIn: 'root',
})
export class PuzzleWinDialogService {
  private viewContainer: ViewContainerRef;
  private injectViewContainer: ViewContainerRef;

  private solutionWord: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public solutionWord$: Observable<string> = this.solutionWord.asObservable();

  private winDialogTitle: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public winDialogTitle$: Observable<string> = this.winDialogTitle.asObservable();

  private buttons: BehaviorSubject<PUZZLE_WIN_DIALOG_BUTTONS[]> = new BehaviorSubject<PUZZLE_WIN_DIALOG_BUTTONS[]>([]);
  public buttons$: Observable<PUZZLE_WIN_DIALOG_BUTTONS[]> = this.buttons.asObservable();

  /*
   * Puzzle types that can end without being solved (Word Guess) hide the leaderboard on a
   * failed attempt, so a fast loss cannot be submitted as a score. Puzzles that never lose
   * leave this untouched and always show it.
   */
  private leaderboardVisible: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public leaderboardVisible$: Observable<boolean> = this.leaderboardVisible.asObservable();

  public solutionDialogDelay = 0;

  public winDialogRegistered: EventEmitter<null> = new EventEmitter<null>();

  constructor(private factoryResolver: ComponentFactoryResolver) {}

  registerViewContainer(viewContainerRef: ViewContainerRef, injectViewContainer: ViewContainerRef) {
    this.viewContainer = viewContainerRef;
    this.injectViewContainer = injectViewContainer;
    this.winDialogRegistered.emit(null);
  }

  /*
   * Called in the constructors of the individual puzzle board components,
   * i.e. CrosswordBoardComponent, which will inject the correct component
   * to display the puzzle specific solution, i.e. CrosswordWinScreenComponent
   * which will receive it's data and instance on Event from winDialogRegistered,
   * which is called when PuzzleWinDialogComponent instantiates.
   */
  injectComponent(ComponentClass, data: any) {
    const factory = this.factoryResolver.resolveComponentFactory(ComponentClass);
    const component = factory.create(this.viewContainer.injector);
    const instance = component.instance as PuzzleWinDialogInjectableInterface;
    instance.setData(data);
    this.injectViewContainer.insert(component.hostView);
  }

  addSolutionWord(solutionWord: string) {
    this.solutionWord.next(solutionWord);
  }

  showButtons(buttons: PUZZLE_WIN_DIALOG_BUTTONS[]) {
    this.buttons.next(buttons);
  }

  setTitle(title: string) {
    this.winDialogTitle.next(title);
  }

  setLeaderboardVisible(visible: boolean) {
    this.leaderboardVisible.next(visible);
  }
}
